import React from 'react'
import {
    useDispatch,
    useSelector
} from 'react-redux'
import { Redirect, Route, useLocation } from 'react-router-dom'
import AppErrorBoundary from '../components/commons/ErrorBoundaries/AppErrorBoundary'
import BaseLayout from '../components/layouts/Admin/BaseLayout'
import adminRoutesConstant from '../constants/adminRoutesConstant'
import { enableRoleBasedRoutes } from '../constants/env'
import { fetchMasterDataDispatcher } from '../redux/dispatchers/masterDataDispatcher'

const AdminRoutes = () => {
    const location = useLocation();
    const auth = useSelector(state => state.auth)

    const dispatch = useDispatch()

    const fetchMD = () => {
        dispatch(fetchMasterDataDispatcher());
    }

    const AppRoutes = (each, index) => {
        const Component = each.component
        const RenderComponent = (props) => (
            <AppErrorBoundary>
                <Component {...each.props} {...props} />
            </AppErrorBoundary>
        )


        if (enableRoleBasedRoutes) {
            // if permission is "null/undefined" then dont render any routes
            if (!auth.admin.permission) {
                return undefined
            }
            else if ((!each.permissionKey || !each.crudType) || (auth.admin.permission && auth.admin.permission[each.permissionKey] && auth.admin.permission[each.permissionKey][each.crudType] == '1')) {
                return (
                    <Route key={index} exact path={each.path} component={RenderComponent} />
                )
            }
        }
        // if role based routing is not enabled... then show all routes (its basically for dev/debugging purpose)
        else {
            return (
                <Route key={index} exact path={each.path} component={RenderComponent} />
            )
        }

    };

    const routes = adminRoutesConstant.guardRoutes.map(AppRoutes).filter(eachRoute => !!eachRoute);

    // if (auth.token) {
    //     return <Redirect to={giftingRoutes.URL_DASHBOARD} />
    // }


    // TODO - enable this expression when auth is working
    if ((location.pathname.includes(adminRoutesConstant.ADMIN_PREFIX)) && (auth.admin && !auth.admin.jwt)) {
        // console.log("ALS", adminRoutesConstant.adminPaths.AdminLoginScreen.url());
        return <Redirect to={adminRoutesConstant.adminPaths.AdminLoginScreen.url()} />
    }

    return (<BaseLayout>{routes}</BaseLayout>)
}

export default AdminRoutes
